import { theme } from "twin.macro";

const size = {
  sm: theme("screens.sm"),
  md: theme("screens.md"),
  lg: theme("screens.lg"),
  xl: theme("screens.xl"),
  xxl: theme("screens.2xl"),
};

export const screen = {
  sm: `@media (min-width: ${size.sm})`,
  md: `@media (min-width: ${size.md})`,
  lg: `@media (min-width: ${size.lg})`,
  xl: `@media (min-width: ${size.xl})`,
  xxl: `@media (min-width: ${size.xxl})`,
};
